module.exports = function() {
  return new Worker(__webpack_public_path__ + "306e0c84be682912f366.worker.js");
};